export default __webpack_public_path__ + "static/newsletter-laptop-579bc7ad52072cbcf3b9543c8c50420d.jpg";